import { ArrowRight, ShieldCheck, X } from "lucide-react";
import { useState } from "react";
import { createCheckout } from "../lib/api";
import type { PublicConfig } from "../types";

type Props = {
  config: PublicConfig;
  open: boolean;
  onClose: () => void;
};

const euros = (cents: number) =>
  new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
  }).format(cents / 100);

export function CreditShop({ config, open, onClose }: Props) {
  const [loading, setLoading] = useState<string | null>(null);
  const [error, setError] = useState("");
  const [immediateSupply, setImmediateSupply] = useState(false);
  if (!open) return null;

  const buy = async (packId: string) => {
    setError("");
    if (!config.paymentsEnabled) {
      setError(
        "Gli acquisti non sono disponibili in questo momento. Riprova più tardi.",
      );
      return;
    }
    try {
      setLoading(packId);
      const { url } = await createCheckout(packId);
      window.location.assign(url);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Checkout non disponibile.");
      setLoading(null);
    }
  };

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        className="credit-shop"
        role="dialog"
        aria-modal="true"
        aria-labelledby="credit-shop-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button className="modal-close" type="button" onClick={onClose}>
          <X aria-hidden="true" /> <span className="sr-only">Chiudi</span>
        </button>
        <h2 id="credit-shop-title">Acquista crediti</h2>
        <p className="credit-shop__intro">
          €0,50 per messaggio, voce inclusa. Il blocco minimo è di 10 crediti e
          il pagamento avviene sulla pagina sicura Stripe.
        </p>
        <div className="pack-list">
          {config.packs.map((pack, index) => (
            <button
              type="button"
              className={index === 0 ? "pack pack--featured" : "pack"}
              onClick={() => buy(pack.id)}
              disabled={loading !== null || !immediateSupply}
              key={pack.id}
            >
              <span>
                <strong>{pack.credits} crediti</strong>
                <small>{pack.name}</small>
              </span>
              <b>{euros(pack.priceCents)}</b>
              <ArrowRight aria-hidden="true" />
            </button>
          ))}
        </div>
        <label className="withdrawal-consent">
          <input
            type="checkbox"
            checked={immediateSupply}
            onChange={(event) => setImmediateSupply(event.target.checked)}
          />
          <span>
            Chiedo che i crediti digitali siano messi a disposizione subito e
            riconosco che, dopo l’inizio dell’utilizzo, il diritto di recesso può
            cessare nei limiti previsti dalla legge.
          </span>
        </label>
        {error ? <p className="form-error">{error}</p> : null}
        <div className="pricing-note">
          <ShieldCheck aria-hidden="true" />
          <p>
            Prezzo fisso di {euros(config.pricing.roundedUnitCents)} per creazione.
            Include generazione del testo, interpretazione vocale e costi del
            servizio.
          </p>
        </div>
        <p className="wallet-warning">
          I crediti restano nel tuo profilo e puoi ritrovarli su un altro telefono.
        </p>
      </section>
    </div>
  );
}
